import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { useGoToFaceDetailsTranslation } from './i18n';
import type { GoToFaceDetailsProps } from './types';
import { buildTestid } from '../../shared/lib/utils';

type GoToFaceDetailsButtonProps = GoToFaceDetailsProps & ButtonProps;

const displayName = 'GoToFaceDetailsButton';
const testid = buildTestid(displayName);

function GoToFaceDetailsButton({
  faceId,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToFaceDetailsButtonProps): React.JSX.Element {
  const { t } = useGoToFaceDetailsTranslation();

  return (
    <Button
      as={Link}
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      size="small"
      to={generatePath(routes.facePage, { faceId })}
      {...testid(dataTestId)}
      {...props}
    >
      {t('title')}
    </Button>
  );
}

GoToFaceDetailsButton.displayName = displayName;

export { GoToFaceDetailsButton };
